import tw from 'tailwind-styled-components'

const TableWrapper = tw.div`
  border
  border-gray-200
  rounded
`

export default TableWrapper
